import { render } from "./Widget.vue?vue&type=template&id=162475d4"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"

import "./Widget.vue?vue&type=style&index=0&id=162475d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/Widget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "162475d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('162475d4', __exports__)) {
    api.reload('162475d4', __exports__)
  }
  
  module.hot.accept("./Widget.vue?vue&type=template&id=162475d4", () => {
    api.rerender('162475d4', render)
  })

}


export default __exports__